import { pxToRem } from '@withjoy/joykit/theme';
import React, { useState, useEffect, useRef } from 'react';
import { Box, CheckboxV2, CheckboxV2Props, Flex, TextV2, TooltipV2 } from '@withjoy/joykit';
import { withWindow } from '@shared/utils/withWindow';

interface ShowAvailableOnlyFacetProps
  extends Readonly<{
    isChecked: boolean;
    onToggle: (event: React.ChangeEvent<HTMLInputElement>) => void;
    title: string;
    checkboxOverrides?: CheckboxV2Props['overrides'];
    tooltipContent?: React.ReactNode;
    showTooltipOnMount?: boolean;
  }> {}

const TOOLTIP_DELAY_MS = 1000;

export const ShowAvailableOnlyFacet: React.FC<ShowAvailableOnlyFacetProps> = ({ title, onToggle, isChecked, tooltipContent, checkboxOverrides, showTooltipOnMount = false }) => {
  const hasShownTooltipRef = useRef(false);
  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);

  useEffect(() => {
    if (!tooltipContent || !showTooltipOnMount || hasShownTooltipRef.current) {
      return;
    }

    const timer = withWindow(
      global =>
        global.setTimeout(() => {
          hasShownTooltipRef.current = true;
          setTooltipIsOpen(true);
        }, TOOLTIP_DELAY_MS),
      undefined,
    );

    return () => withWindow(global => global.clearTimeout(timer));
  }, [tooltipContent, showTooltipOnMount]);

  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTooltipIsOpen(false);
    onToggle(event);
  };

  const label = (
    <TextV2
      color="mono14"
      typographyVariant="body1"
    >
      {title}
    </TextV2>
  );

  return (
    <Flex flexDirection="column">
      <CheckboxV2
        isChecked={isChecked}
        onChange={handleToggle}
        id="show-available-only"
        overrides={checkboxOverrides}
      >
        {tooltipContent ? (
          <TooltipV2
            triggerType="none"
            isOpen={tooltipIsOpen}
            onClose={() => setTooltipIsOpen(false)}
            overrides={{
              Content: { props: { paddingY: 4, paddingLeft: pxToRem(14), paddingRight: 4, borderRadius: pxToRem(12), color: 'white', marginLeft: 2 } },
            }}
            content={
              <Box
                typographyVariant="label2"
                maxWidth={pxToRem(300)}
              >
                {tooltipContent}
              </Box>
            }
            placement="top"
          >
            <span>{label}</span>
          </TooltipV2>
        ) : (
          label
        )}
      </CheckboxV2>
    </Flex>
  );
};
